import { HttpError } from "@/data/requests";
import includes from "lodash/includes";

const backendErrorCodes = [
  "INVALID_CODE",
  "LOGIN_FAILED",
  "MFA_SETUP_REQUIRED",
  "RESET_PASSWORD_ALREADY_EXECUTED",
  "RESET_PASSWORD_TOKEN_EXPIRED",
  "SESSION_EXPIRED",
  "SIGN_UP_INVITATION_ALREADY_ACCEPTED",
  "SIGN_UP_INVITATION_EXPIRED",
  "UNKNOWN_ERROR",
  "USER_DISABLED",
  "WEAK_PASSWORD",
] as const;

type BackendErrorCodes = typeof backendErrorCodes;

export type BackendErrorCode = BackendErrorCodes[number];

export const backendErrorCodeFor = (error?: Error | null): BackendErrorCode | null => {
  if (error instanceof HttpError) {
    const responseBody = error.responseJson as { code?: string } | undefined;
    const errorCode = responseBody?.code;
    return includes(backendErrorCodes, errorCode)
      ? (responseBody!.code! as BackendErrorCode)
      : errorCode
        ? "UNKNOWN_ERROR"
        : null;
  } else {
    return null;
  }
};
